<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 mt-10 mb-10">
        <div>
          <div class="flex flex-col gap-5">
            <div class="flex cursor-pointer">
              <router-link
                :to="{ name: 'HodBatches' }"
                class="cursor-pointer bg-blues hover:bg-blue-600 text-white px-3 py-1 text-sm font-bold rounded-2xl"
              >
                Back
              </router-link>

              <!-- <p
                class="bg-primary text-sm text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
              >
                Back
              </p> -->
            </div>

            <h1 class="text-primary text-xl font-bold">Semesters</h1>

             <div v-if="loading">
              <p>loading...</p>
            </div>

            <div
              v-if="this.semeterList.length > 0"
              class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5"
            >
              <div
                v-for="semester in semeterList"
                :key="semester"
                class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
              >
                <div class="lg:px-8 h-full px-6 flex flex-col gap-4">
                  <!-- {{ semester }} -->

                  <h1 class="font-bold text-lg lg:text-lg prime text-left">
                    Program : <span class="font-normal">{{ semester.department.program.name || "Na" }} </span>
                  
                  </h1>

                  <h1 class="font-bold text-md prime text-left">
                      Semester {{ semester.semester }}
                  </h1>

                  <!-- <p>Batch: {{ currentBatchData.year }}</p> -->

                  <p>Courses: {{ semester.course_count }}</p>
                  <router-link
                    :to="{
                      name: 'HodCourses',
                      params: { semester: semester.id, batch: this.batch },
                    }"
                    class="bg-blues hover:bg-blue-600 text-sm text-white px-6 py-1.5 rounded-full text-center cursor-pointer"
                  >
                    Courses
                  </router-link>

                  <!-- <p
                    @click="getSemesterCourses(semester.id, semester)"
                    class="bg-primary text-white text-sm px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                  >
                    Semester Courses
                  </p> -->
                </div>
              </div>
            </div>
            <div v-if="!loading && this.semeterList.length == 0">No data found</div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

import axios from "axios";

import NewCourse from "./NewCourse.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import EditCourse from "./EditCourse.vue";
import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";
import { faL } from '@fortawesome/free-solid-svg-icons';

export default {
  components: {
    HodHeader,
    CoordinateHeader,
    Header,
    Footer,
    NewCourse,
    ConfirmPopup,
    EditCourse,
    AddLessonUnit,
    InstructorHeader,
  },

  props: ["batch"],

  computed: mapGetters(["userInfo"]),

  data() {
    return {
      semeterList: [],
      loading: false
    };
  },

  created() {
    this.getSemesterList(this.batch);
  },

  methods: {
    getSemesterList(id) {
      this.loading = true;
      this.semeterList = [];

      axios
        .get(
          `${process.env.VUE_APP_API}/hod/semesters-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status == 200) {
            this.loading = false;
            this.semeterList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // getSemesterCourses(id, data) {
    //   this.courseList = [];
    //   this.semesterId = id;
    //   this.currentSemesterData = data;
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/hod/course-list/${id}/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.courseList = response.data.data;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
};
</script>

<style></style>
